import { useEffect } from "react";
import { SEO } from "@/components/SEO";
import { HeroSection } from "@/components/home/HeroSection";
import { OfferingsSection } from "@/components/home/OfferingsSection";
import { VerticalIntegrationSection } from "@/components/home/VerticalIntegrationSection";
import { MetricsSection } from "@/components/home/MetricsSection";
import { FeaturedProductsSection } from "@/components/home/FeaturedProductsSection";
import { GlobalReadinessSection } from "@/components/home/GlobalReadinessSection";
import { QualitySection } from "@/components/home/QualitySection";
import { InsightsSection } from "@/components/home/InsightsSection";
import { ContactSection } from "@/components/home/ContactSection";

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "KF Prints Pvt. Ltd.",
  url: window.location.origin,
  logo: `${window.location.origin}/kf-logo.png`,
  description: "Textile manufacturer and fabric exporter based in Surat, India with 75+ years of legacy. Brands: Krish Fashion (unstitched dress materials), IOLY (readymade garments) and KF Prints fabrics.",
  foundingDate: "1950",
  address: { "@type": "PostalAddress", addressLocality: "Surat", addressRegion: "Gujarat", addressCountry: "IN" },
  contactPoint: { "@type": "ContactPoint", telephone: "+91-6355402541", contactType: "sales", email: "info@kfprints.com" },
  brand: [
    { "@type": "Brand", name: "Krish Fashion" },
    { "@type": "Brand", name: "IOLY" },
    { "@type": "Brand", name: "KF Prints" },
  ],
  areaServed: ["India", "United Arab Emirates", "Saudi Arabia"],
};

export default function HomePage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="home-page">
      <SEO
        title="KF Prints Pvt. Ltd. | Premium Textile Manufacturer & Fabric Exporter — Surat, India"
        description="75+ years of textile excellence from Surat, India. Unstitched dress materials (Krish Fashion), readymade garments (IOLY) and premium printed fabrics — manufactured at scale and exported to Dubai, Saudi Arabia and beyond."
        keywords="textile manufacturer India, fabric exporter Surat, unstitched dress materials, readymade garments manufacturer, printed fabrics supplier, textile sourcing India, Krish Fashion, IOLY"
        path="/"
        jsonLd={orgJsonLd}
      />
      <HeroSection />
      <OfferingsSection />
      <VerticalIntegrationSection />
      <MetricsSection />
      <FeaturedProductsSection />
      <GlobalReadinessSection />
      <QualitySection />
      <InsightsSection />
      <ContactSection />
    </div>
  );
}
